/**
 * Sidebar entries the ledger feature contributes — a contribution file the
 * shell merges into the route registry; nothing self-registers. Permissions
 * are the canonical strings from openapi/generated/route_policy.gen.go.
 */
import {
  ArrowLeftRight,
  BookOpenCheck,
  CalendarRange,
  FileUp,
  ListTree,
  Scale,
  TriangleAlert,
  Workflow,
} from "lucide-react";

import type { NavEntry } from "@/app-shell/route-registry";

export const ledgerNavEntries: NavEntry[] = [
  {
    path: "/ledger/accounts",
    labelKey: "ledger.nav.accounts",
    icon: ListTree,
    permission: "ledger.account.read",
  },
  {
    path: "/ledger/accounts/import",
    labelKey: "ledger.nav.accountImport",
    icon: FileUp,
    permission: "ledger.account.import.preview",
  },
  {
    path: "/ledger/journals",
    labelKey: "ledger.nav.journals",
    icon: BookOpenCheck,
    permission: "ledger.journal.read",
  },
  {
    path: "/ledger/trial-balance",
    labelKey: "ledger.nav.trialBalance",
    icon: Scale,
    permission: "ledger.trial-balance.read",
  },
  {
    path: "/ledger/posting-rules",
    labelKey: "ledger.nav.postingRules",
    icon: Workflow,
    permission: "ledger.posting-rule.read",
  },
  {
    path: "/ledger/fx-rates",
    labelKey: "ledger.nav.fxRates",
    icon: ArrowLeftRight,
    permission: "ledger.fx-rate.read",
  },
  {
    path: "/ledger/failed-events",
    labelKey: "ledger.nav.failedEvents",
    icon: TriangleAlert,
    permission: "ledger.business-event.read",
  },
  {
    path: "/ledger/fiscal-periods",
    labelKey: "ledger.nav.fiscalPeriods",
    icon: CalendarRange,
    permission: "ledger.fiscal-period.read",
  },
];
